// extracted by mini-css-extract-plugin
export default {"dateInput":"datepicker_dateInput__JiFJq","dateLabel":"datepicker_dateLabel__++yJm"};